import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Attachment } from '../models/project/attachment/attachment.interface';

@Injectable()
export class InventoryItemAttachmentService {
  private readonly httpClient = inject(HttpClient);

  private attachmentsUrl = '';

  public setAttachmentsUrl(companyId: string, itemId: string): void {
    this.attachmentsUrl = `${environment.apiUrl}/companies/${companyId}/inventory-items/${itemId}/attachments`;
  }

  public getInventoryItemAttachments(): Observable<Attachment[]> {
    return this.httpClient.get<Attachment[]>(this.attachmentsUrl);
  }

  public createAttachment(attachment: Attachment, correlationId?: string): Observable<Attachment> {
    return this.httpClient.post<Attachment>(this.attachmentsUrl, attachment, {
      headers: this.buildHeaders(correlationId),
    });
  }

  public deleteAttachment(id: string): Observable<null> {
    return this.httpClient.delete<null>(`${this.attachmentsUrl}/${id}`);
  }

  public renameAttachment(id: string, fileName: string): Observable<Attachment> {
    return this.httpClient.put<Attachment>(`${this.attachmentsUrl}/${id}`, {
      fileName,
    });
  }

  private buildHeaders(correlationId?: string): HttpHeaders | undefined {
    if (!correlationId) {
      return undefined;
    }

    return new HttpHeaders({
      'X-Correlation-Id': correlationId,
    });
  }
}
